import { render, staticRenderFns } from "./treatments-management-container.vue?vue&type=template&id=3c75235a&scoped=true&lang=pug"
import script from "./treatments-management-container.js?vue&type=script&lang=js&external"
export * from "./treatments-management-container.js?vue&type=script&lang=js&external"
import style0 from "./treatments-management-container.vue?vue&type=style&index=0&id=3c75235a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c75235a",
  null
  
)

export default component.exports